import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme = responsiveFontSizes(
  createTheme({
    /*
     * Mirrors the $breakpoints map in scss/core/_variables.scss. MUI's own
     * defaults put md at 900px while the stylesheets use 768px, so a component
     * asking useMediaQuery for "down md" disagreed with its own CSS between
     * those two widths — the quiz page hid its question rail while the styles
     * still left a gutter for it.
     */
    breakpoints: {
      values: {
        xs: 0,
        mobileSmall: 375,
        mobile: 414,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
        xxxl: 1600,
        xxxxl: 1900,
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: 'black',
            color: 'white',
            border: '',
            fontSize: '0.8rem',
          },
        },
      },
    },
    palette: {
      primary: {
        dark: '#0A192D',
        main: '#003057',
        light: '#F0F8FF',
        contrastText: '#FFFFFF',
      },
      error: {
        main: '#960200',
      },
    },
    typography: {
      fontFamily: "'Lato', Arial, Helvetica, sans-serif",
      h1: {
        fontSize: '2.2rem',
        fontWeight: 600,
      },
      h2: {
        fontSize: '2.0rem',
        fontWeight: 600,
      },
      h3: {
        fontSize: '1.5rem',
        fontWeight: 600,
      },
      h4: {
        fontSize: '1.3rem',
        fontWeight: 600,
      },
      h5: {
        fontSize: '1.2rem',
        fontWeight: 600,
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      p: {
        fontSize: '0.9rem',
      },
      small: {
        fontSize: '0.9rem',
      },
      smaller: {
        fontSize: '0.8rem',
      },
      smallest: {
        fontSize: '0.75rem',
      },
    },
  }),
);

export default theme;
